// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1ARei","large":"styles_large__3ZMVF"};